module.exports = __webpack_public_path__ + "static/concert-hall-music-republicain-1b9d49b587b4d2495e6a7483a9484ac3.jpg";